import cn from 'classnames';

import { howActiveItems } from '../../constants/questioner';
import SelectImageButtons from '../SelectImageButtons/SelectImageButtons';
import ProgressBar from '../ProgressBar/ProgressBar';

import styles from './Steps.module.css';

const Step6 = (props) => {
  const { onSave, stepsData } = props;

  const onSaveHandler = (physicalActivity) => {
    onSave({ physical_activity: physicalActivity });
  };

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.physicalActivity}>
        <div className={cn(styles.stepHeader, styles.nowrap)}>
          How active are you?
        </div>
        <div className={styles.selectButtonsWrapper}>
          <SelectImageButtons
            buttonsData={howActiveItems}  
            onChange={onSaveHandler}
            defaultValue={stepsData.physical_activity}
          />
        </div>
      </div>
    </div>
  );
};

export default Step6;